var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagPol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_587",
    "data-name": "Ret\\xE2ngulo 587",
    width: 60,
    height: 60,
    transform: "translate(1851 3187)",
    fill: "#fff",
    opacity: 0.41
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag_POL",
    transform: "translate(-1851 -3187)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag_polonia",
    transform: "translate(1830.882 3187)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_513",
    "data-name": "Ret\\xE2ngulo 513",
    width: 102.837,
    height: 29.995,
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_514",
    "data-name": "Ret\\xE2ngulo 514",
    width: 102.837,
    height: 29.99,
    transform: "translate(0 29.995)",
    fill: "#d80031"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagPol);
export default __webpack_public_path__ + "static/media/flag_POL.6d3a5e90fedb3ee7268760a1f86fa7db.svg";
export { ForwardRef as ReactComponent };